import React from "react";

export const DownloadIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M10 16L5 11M10 16L15 11M10 16V5" stroke="#0069B4" />
            <circle cx="10" cy="10" r="9.5" stroke="#0069B4" />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/views/documentation/components/DownloadIcon.tsx